// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDZn272wk4gF3MDT42h68F5-FUBuhizrKY",
  authDomain: "utwin-webapp.firebaseapp.com",
  projectId: "utwin-webapp",
  storageBucket: "utwin-webapp.firebasestorage.app",
  messagingSenderId: "71548237839",
  appId: "1:71548237839:web:d501de41ca208dcb3ecb7a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

